export default __webpack_public_path__ + "static/accountHero-1a9c588a85220b689f51db1b4b9afbff.jpg";